import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import type { Dispatch, FC } from "react";
import type { DigitalSampleRequestCreateResponse } from "../../../service/create-digital-sample.request";

export interface DigitalSampleRequestDialogProps {
  open: boolean;
  onClose: Dispatch<void>;
  response?: DigitalSampleRequestCreateResponse;
}

export const DigitalSampleRequestCompletedDialog: FC<
  DigitalSampleRequestDialogProps
> = ({ open, onClose, response }) => {
  const handleClose = () => {
    onClose();
  };

  if (response?.error) {
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Request creation failed</DialogTitle>
        <DialogContent>
          <DialogContentText>{response?.error.message}</DialogContentText>
        </DialogContent>
        <Stack alignItems="center" mt={1} mb={-2}>
          <ErrorIcon sx={{ fontSize: 50 }} color="error" />
        </Stack>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Request successfully created</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your request has been successfully created!
        </DialogContentText>
        <Stack alignItems="center" mt={1} mb={-2}>
          <CheckCircleIcon sx={{ fontSize: 50 }} color="success" />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
